import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../api';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

export default function LoginPage() {
  const navigate              = useNavigate();
  const { token, loading, saveSession } = useAuth();

  const [identifier, setIdentifier] = useState('');
  const [password,   setPassword]   = useState('');
  const [busy,       setBusy]       = useState(false);
  const [error,      setError]      = useState('');

  // Already logged in → go straight to dashboard
  useEffect(() => {
    if (!loading && token) navigate('/vendor/dashboard', { replace: true });
  }, [loading, token, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!identifier.trim() || !password.trim()) {
      setError('Please enter your Business ID (or email) and password.');
      return;
    }
    setError('');
    setBusy(true);
    try {
      const res = await login({ identifier: identifier.trim(), password });
      saveSession(res.token, res.business);
      navigate('/vendor/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Check your credentials and try again.');
    } finally {
      setBusy(false);
    }
  };

  if (loading) return null; // AuthContext is still checking localStorage

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><Logo size="lg" /></div>
        <h2 className="auth-title">Vendor Login</h2>
        <p className="auth-sub">Sign in to manage your orders and menu</p>

        <form onSubmit={submit}>
          {error && <div className="auth-error">{error}</div>}

          <div className="auth-field">
            <label>Business ID or Email</label>
            <input
              className="auth-input"
              placeholder="EASY0001 or you@example.com"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
            />
          </div>

          <div className="auth-field">
            <label>Password</label>
            <input
              className="auth-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="auth-btn" type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <p className="auth-footer">
          New shop? <Link to="/vendor/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}
